import React from 'react';

/** Ловит падение любого экрана и показывает текст вместо белой страницы.
 *
 *  Дважды в сентябре обращение к `const` выше его объявления роняло лендинг,
 *  и вместе с ним — форму входа: пользователь видел пустой белый экран и
 *  ничего не мог сделать, а в консоль заглядывают не все. Причина каждый раз
 *  была разной, поэтому чинить нужно не конкретную строку, а последствие:
 *  сломанный экран должен оставаться сломанным экраном, а не всем сайтом.
 *
 *  Линтер такие случаи не ловит: `no-use-before-define` в этом проекте даёт
 *  91 срабатывание на безопасных функциях внутри колбэков, и включать его
 *  ошибкой значит остановить сборку из-за шума.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Стек в консоль — по нему видно, какой именно экран упал.
    console.error('Экран упал:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background">
        <div className="max-w-lg w-full rounded-lg border p-6 text-center space-y-4">
          <h1 className="text-lg font-semibold">Раздел не открылся</h1>
          <p className="text-sm text-muted-foreground">
            Произошла ошибка при отрисовке. Обновите страницу — если повторится,
            покажите этот текст разработчику.
          </p>
          <pre className="text-[11px] text-left bg-muted/50 rounded p-3 overflow-auto max-h-40">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="flex gap-2 justify-center">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-md border text-sm hover:bg-muted"
            >
              Обновить страницу
            </button>
            <button
              type="button"
              onClick={() => { window.location.href = '/'; }}
              className="px-4 py-2 rounded-md border text-sm hover:bg-muted"
            >
              На главную
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
